import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userId: '',
    userPassword: '',
    userName: '',
    sessionId: '',
    logindate: '', 
    companyName: '',
    admin:'',
    companySeq: '',
    companyType: '',
    devType: '',
    userPhoneNum: '',
    userSendOtpType: '',
    deptName: '',
    kindName: '',
    userRole: ''
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setResultLogin: (state, action) => {
            // return {...state, ...action.payload};
            const updates = action.payload;
            // for (const key in updates) {
            //     if (Object.prototype.hasOwnProperty.call(updates, key)) {
            //         state[key] = updates[key];
            //     }
            // }
            Object.keys(updates).forEach(key => {
                state[key] = updates[key];
            });
        },
        setLoginInfo: (state, action) => {
            const updates = action.payload;
            for (const key in updates) {
                if (Object.prototype.hasOwnProperty.call(updates, key)) {
                    state[key] = updates[key];
                }
            }
        },
        init: () => initialState
    }
});

export const { setResultLogin, setLoginInfo, init } = loginSlice.actions;
export default loginSlice.reducer;